import styled from "styled-components"
const biggestTablet = 768
const biggestPhone = 429

export const onPhone = `@media (max-width: ${biggestPhone}px)`
export const notPhone = `@media (min-width: ${biggestPhone + 1}px)`
export const onTablet = `@media (max-width: ${biggestTablet}px) and (min-width: ${biggestPhone +
  1}px)`
export const onDesktop = `@media (min-width: ${biggestTablet + 1}px)`
export const notDesktop = `@media (max-width: ${biggestTablet}px)`

export const OnPhone = styled.div`
  ${notPhone} {
    display: none;
  }
`

export const NotPhone = styled.div`
  ${onPhone} {
    display: none;
  }
`

export const NotDesktop = styled.div`
  ${onDesktop} {
    display: none;
  }
`

export const OnDesktop = styled.div`
  display: none;
  ${onDesktop} {
    display: unset;
  }
`
